import { InternationalizationNameSpace } from 'core/models/internationalization-namespace';
import { Icon } from 'hfs-common-ui';
import { setIsOpenSalesCompanyCodesGuide } from 'feature/auth/store';
import { useAppDispatch } from 'core/hooks/use-app-dispatch';
import { ActiveModal, setActiveModal } from 'core/layout/reducer';
import { useCallback } from 'react';
import { useTranslationWrapper } from 'core/hooks/use-translation-wrapper';
import * as S from './styled';

interface Props {
  size: 'small' | 'medium';
  icon?: string;
}

const UserSalesCompanyCodesInformation = ({ icon, size }: Props) => {
  const { t } = useTranslationWrapper(InternationalizationNameSpace.Auth);
  const dispatch = useAppDispatch();

  // Handles click event to open guide for sales company codes.
  const handleSalesCompanyCodesGuideClick = useCallback(() => {
    dispatch(setActiveModal(ActiveModal.SALES_COMPANY_CODE));
    dispatch(setIsOpenSalesCompanyCodesGuide(true));
  }, [dispatch]);

  return (
    <S.SalesCompanyCodesInformationDiv id="abt_sales_code" onClick={handleSalesCompanyCodesGuideClick}>
      {icon && <Icon type={icon} size={size} color="brandPrimary" />}
      <S.SalesCompanyCodesGuideSpan>
        {t('AUTH:info.aboutSalesCompaniesCodesInformation').toUpperCase()}
      </S.SalesCompanyCodesGuideSpan>
    </S.SalesCompanyCodesInformationDiv>
  );
};

export default UserSalesCompanyCodesInformation;
